/**
 *
 * linkeMe拉起
 * 项目模板需要引入局链接 <script src="https://static.lkme.cc/linkedme.min.js" ></script>
 * 初始化为：
 *         <script type="text/javascript">
 *           var initData = {};
 *               initData.type = "live";
 *          linkedme.init("8ed6e92a13d1e959b4d7d2661f7efec2", initData, null);
 *         </script>
 * API文档地址：https://pagedoc.lkme.cc/linkpage/linkpage-integration/js-sdk.html
 *
 * @视频客户端linkedme.link中dataObj参数说明：
 * 点播视频 {"type":"video","guid":"64e5352f-4eee-4a79-b449-7c3ee184bf86","channel":"sf"}
 * 直播视频 {"type":"live","guid":"30e8fa4a-9646-4371-ab99-6e0a035c9032","channel":"sf"}
 * vr直播 {"type":"vrlive","id":"111","guid":"30e8fa4a-9646-4371-ab99-6e0a035c9032","vrurl":"https://ips.ifeng.com/video19.ifeng.com/video09/2018/07/07/35902699-102-009-152749.mp4","channel":"sf"}
 * 专题 {"type":"special","id":"70146","guid":"0146b5ef-565a-4210-bd7e-67e134434acd","channel":"sfl"}
 * 焦点 {"type":"focus","id":"70582","guid":"014f0bd1-63e2-4988-a9f5-4af92447e06e","channel":"sf"}
 * 连播台 {"type":"lianbo","id":"68927","guid":"d30e1963-2ec6-46c7-b114-25f3ca44a111","channel":"sf"}
 * 小视频 {"type":"plantainvideo","guid":"64e5352f-4eee-4a79-b449-7c3ee184bf86","channel":"wx"}
 * 网页 {"type":"web","id":"123","guid":"aHR0cDovL3YuaWZlbmcuY29t","channel":"sf"}
 * 免费订购网页
 */
/**
 *
 * option为拉起参数配置项目
 * pageDom操作dom元素
 * callbackLinkMeUrl返回链接参数
 *
 */
const linkedMeVideoApp = (option, pageDom, callbackLinkMeUrl) => {
    // const type = (option.type && `'type':'${option.type}',`) || '';
    // const id = (option.id && `'id':'${option.id}',`) || '';
    // const guid = (option.guid && `'guid':'${option.guid}',`) || '';
    // const channel = (option.channel && `'channel':'${option.channel}',`) || '';
    // const vrurl = (option.vrurl && `'vrurl': '${option.vrurl}',`) || '';
    if (!option || !window.linkedme) {
        console.log('检查是否配置option相关参数以及linkedme包的引入');

        return false;
    }

    const dataConfig = {
        params: JSON.stringify(option),
        type: 'live',
    };

    try {
        window.linkedme.link(
            dataConfig,
            (err, response) => {
                if (err || !response.url) {
                    console.log(err, 'linkme链接生成失败');
                } else {
                    if (pageDom) {
                        pageDom.setAttribute('href', response.url);

                        pageDom.addEventListener('click', () => {
                            window.linkedme.trigger_deeplink(response.url);
                        });
                    }

                    if (callbackLinkMeUrl) {
                        callbackLinkMeUrl(response.url);
                    }
                }
            },
            false,
        );
    } catch (error) {
        console.log(error, 'linkme链接生成失败');
    }
};

export { linkedMeVideoApp };
